/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HospitalSnfStay } from './HospitalSnfStay';
import {
    HospitalSnfStayFromJSON,
    HospitalSnfStayFromJSONTyped,
    HospitalSnfStayToJSON,
} from './HospitalSnfStay';

/**
 * 
 * @export
 * @interface HospitalSnfStays
 */
export interface HospitalSnfStays {
    /**
     * 
     * @type {Array<HospitalSnfStay>}
     * @memberof HospitalSnfStays
     */
    snf_stays?: Array<HospitalSnfStay>;
    /**
     * 
     * @type {any}
     * @memberof HospitalSnfStays
     */
    hospital_stays?: any | null;
}

/**
 * Check if a given object implements the HospitalSnfStays interface.
 */
export function instanceOfHospitalSnfStays(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HospitalSnfStaysFromJSON(json: any): HospitalSnfStays {
    return HospitalSnfStaysFromJSONTyped(json, false);
}

export function HospitalSnfStaysFromJSONTyped(json: any, ignoreDiscriminator: boolean): HospitalSnfStays {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'snf_stays': !exists(json, 'snf_stays') ? undefined : ((json['snf_stays'] as Array<any>).map(HospitalSnfStayFromJSON)),
        'hospital_stays': !exists(json, 'hospital_stays') ? undefined : json['hospital_stays'],
    };
}

export function HospitalSnfStaysToJSON(value?: HospitalSnfStays | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'snf_stays': value.snf_stays === undefined ? undefined : ((value.snf_stays as Array<any>).map(HospitalSnfStayToJSON)),
        'hospital_stays': value.hospital_stays,
    };
}

